// Import libraries

import React, { useEffect, useState } from 'react';
import { SafeAreaView, StyleSheet } from 'react-native';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import Toast from 'react-native-toast-message';
import * as Font from 'expo-font';
import AppNavigator from './navigation/AppNavigator';

// Reducers
import globalReducers from './store/reducers/globalReducers';

const rootReducer = combineReducers({
	globals: globalReducers,
});

const store = createStore(rootReducer, applyMiddleware(ReduxThunk));

const App = () => {

	const [appIsReady, setAppIsReady] = useState(false);

	useEffect(() => {
		const load = async () => {
			try {
				await Font.loadAsync({
					'poppins': require('./assets/fonts/poppins/Poppins-Regular.ttf'),
					'poppins-bold': require('./assets/fonts/poppins/Poppins-Bold.ttf'),
				});
			}
			catch (e) {
				console.warn(e);
			}
			finally {
				setAppIsReady(true);
			}
		};
		load();
	}, []);


	if (!appIsReady) return null;

	return (
		<SafeAreaView
			style={styles.screen}
		>
			<Provider store={store}>
				<AppNavigator/>
				<Toast/>
			</Provider>
		</SafeAreaView>
	);
};

const styles = StyleSheet.create({
	screen: {
		flex: 1,
	}
});

export default App;